import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const deleteMessage = async (messageId, folderId, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + `folders/${folderId}/message/${messageId}`;

  // Define headers for the request
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the DELETE request
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
      body: null, // Body is unnecessary for DELETE requests here
    });

    // Check Firebase authentication
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User not logged in");
    }

    // Access Firestore and get the user document
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return;
    }

    // Get organization reference from user document
    const org_id = userSnapshot.get("org_id");

    // Log the API request and response in Firestore
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Optional additional fields
      "",
      "", // Empty body
      await response.text() // Response body as text
    );

    // Check if the request was successful
    if (response.ok) {
      return "Message deleted successfully"; // Return success message or process as needed
    } else {
      console.error(`Failed to delete message: ${response.status}`);
      return `Error: Failed to delete message with status ${response.status}`;
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return `Error: ${error.message}`;
  }
};

export default deleteMessage;
